import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useGet } from '../../lib/api/hooks';
import { useScreenSmallerThan } from '../../lib/hooks/breakpoint-hooks';
import { CustomDateHourCell } from '../../lib/helper/time-formatter';
import Card from '../Utils/Card';
import { useEffect } from 'react';
import { AuditHistoryModel } from '../../lib/models/AuditHistoryModel';
import { Typography } from '@mui/material';

const columns: GridColDef[] = [
    {
        field: 'timestamp',
        headerName: 'Changed Date',
        maxWidth: 150,
        flex: 1,
        renderCell: (params) => (
            <CustomDateHourCell
                timeValue={params.row.formattedTime}
                dateValue={params.row.formattedDate}
            />
        )
    },
    { field: 'changedBy', headerName: 'Changed By', maxWidth: 300, flex: 1 },
    { field: 'event', headerName: 'Event', maxWidth: 250, flex: 1 },
    {
        field: 'value',
        headerName: 'Value',
        flex: 1,
        renderCell: (params) => {
            return <Typography sx={{ whiteSpace: 'pre-line' }}>{params.row.value}</Typography>;
        }
    }
];

type AuditHistoryProps = {
    clinicalReviewId: string;
    isCosign: string | undefined;
    onApiData?: (data: AuditHistoryModel[]) => void;
};

const AuditHistory = ({ clinicalReviewId, isCosign, onApiData }: AuditHistoryProps) => {
    const { data } = useGet<AuditHistoryModel[]>(
        `audit/getaudithistoryforcase?clinicalReviewId=${clinicalReviewId}&isCosigned=${isCosign}`
    );

    useEffect(() => {
        data != null && onApiData && onApiData(data);
    }, [data, onApiData]);

    const isSmallerThanSmall = useScreenSmallerThan('sm');

    return (
        <>
            {data && (
                <Card
                    sx={{ width: '97%', margin: isSmallerThanSmall ? '10px 0' : '10px 20px 20px' }}>
                    <Card.Title>History</Card.Title>
                    <Card.Body>
                        <DataGrid
                            sx={{ border: 0 }}
                            getRowHeight={() => 'auto'}
                            rows={data}
                            columns={columns}
                            pagination
                        />
                    </Card.Body>
                </Card>
            )}
        </>
    );
};

export default AuditHistory;
